import { createAction } from '@reduxjs/toolkit'

export const selectCurrency = createAction<{ currencyId: string }>('buyBackAndBurn/selectCurrency')
export const resetCurrency = createAction('buyBackAndBurn/resetCurrency')
export const reset = createAction('buyBackAndBurn/reset')
export const selectSourceChain = createAction<{ sourceChainId: number }>('buyBackAndBurn/selectSourceChain')
export const setTransactionHash = createAction<{ sourceChainId: number; transactionHash: string }>(
  'buyBackAndBurn/setTransactionHash',
)
